import QTableBody from '@mui/material/TableBody';
import { styled } from '@mui/material/styles';

export const KwTableBody = styled(QTableBody)``;
